import http from 'conversations-http/clients/http';
export const getForm = ({
  formId
}) => http.get(`cv-forms-integration-legacy/v1/connected-crm-object/object-type-id/form_submission/connected-object-source-id/${formId}`);